export enum CardState {
  IDLE,
  LOADING_DESCRIPTION,
  LOADING_IMAGE,
  SAVING,
  SUCCESS,
  ERROR,
}

export enum CardType {
  CHARACTER = 'character',
  SUPPORT = 'support',
  ENVIRONMENT = 'environment',
}

export interface CharacterData {
  description: string;
  description_ja?: string; // Japanese translation
  mainColors: string[]; // Array of hex color codes
  mainObjects: string[]; // Array of identified objects
  cardType: CardType;
}

/**
 * Firestore Timestamp / Date / ISO文字列のいずれかで読み出される可能性のあるタイムスタンプ
 * （Firestore SDK に依存しないよう構造的に定義）
 */
export interface FirestoreTimestampLike {
  toDate(): Date;
}
export type TimestampValue = FirestoreTimestampLike | Date | string;

/** 生成ステップ（解析・日記・画像）ごとのモデル／プロンプト版の記録 */
export interface GenerationStepMetadata {
  model: string;
  /** プロンプトの識別子。プロンプト本文は保存しない */
  promptVersion: string;
  /** ISO 8601 文字列（HTTPレスポンス／Firestoreともに文字列で保持） */
  generatedAt: string;
}

/** どのモデル・プロンプト版が各ステップを生成したか。既存カードには存在しない（任意） */
export interface GenerationMetadata {
  analysis?: GenerationStepMetadata;
  diary?: GenerationStepMetadata;
  image?: GenerationStepMetadata;
}

export type DescriptionSource = 'ai' | 'user-edited';

/** 日本語日記（description_ja）の出自と手動編集の履歴。既存カードには存在しない（任意） */
export interface DescriptionMetadata {
  source: DescriptionSource;
  editCount: number;
  lastEditedAt?: TimestampValue;
}

export interface ExifData {
  latitude?: number;
  longitude?: number;
  createDate?: Date;
  model?: string;
}

export interface User {
  id: string;
  email: string;
  displayName?: string;
  photoURL?: string;
  createdAt: Date;
  updatedAt: Date;
}

// 公開プロフィール情報（users_publicコレクション用）
export interface UserPublicProfile {
  id: string;
  displayName?: string;
  photoURL?: string;
  createdAt: Date;
  updatedAt: Date;
}

// 機密情報（users_privateコレクション用）
export interface UserPrivateData {
  id: string;
  email: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CharacterCard {
  id: string;
  userId: string; // ユーザーID（必須フィールド）
  originalFile?: File;
  originalImageUrl?: string;
  characterData: CharacterData | null;
  exifData: ExifData | null;
  pixelArtUrl: string | null;
  status: CardState;
  error: string | null;
  createdAt?: Date;
  updatedAt?: Date;
  generateDescription?: boolean; // Description自動生成フラグ（デフォルト: true）
  /** 生成メタデータ（新規カードのみ。既存カードでは undefined） */
  generationMetadata?: GenerationMetadata;
  /** 日本語日記の出自・編集履歴（新規カードのみ。既存カードでは undefined） */
  descriptionMeta?: DescriptionMetadata;
}
